import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createIngredient,
    updateIngredient,
    clearMessages as clearIngredientMessages
} from '../../../redux/slices/admin/ingredientsSlice';

const IngredientModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        ingredient_name: '',
        unit: '',
        protein: '',
        carb: '',
        fat: ''
    });

    const successMessage = useSelector((state) => state.admin_ingredients?.successMessage);
    const errorMessage = useSelector((state) => state.admin_ingredients?.error);
    const unitsMin = useSelector((state) => state.app_options?.units_min);

    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                ingredient_name: initialData.ingredient_name || '',
                unit: initialData.unit || '',
                protein: initialData.protein_per_unit || '',
                carb: initialData.carb_per_unit || '',
                fat: initialData.fat_per_unit || ''
            });
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        const { name, value, files } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === 'ingredient_picture' ? files[0] : value,
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const payload = {
            id: isEditMode ? initialData.id : undefined, // Include id if editing
            ingredient_name: formData.ingredient_name,
            unit: formData.unit,
            protein: formData.protein,
            carb: formData.carb,
            fat: formData.fat
        };

        if (isEditMode) {
            await dispatch(updateIngredient(payload)); // Send payload directly
        } else {
            await dispatch(createIngredient(payload)); // Send payload directly
        }
    };

    const handleClose = () => {
        dispatch(clearIngredientMessages());
        // Clear the form data only when the modal is closed
        setFormData({
            ingredient_name: '',
            unit: '',
            protein: '',
            carb: '',
            fat: ''
        });
        closeModal();
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="modalNutritionIngredientsLabel">{isEditMode ? 'Edit Ingredient' : 'Create New Ingredient'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-body px-md-5 pb-md-4">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        placeholder="Ingredient Name"
                                        className="form-control form-control-lg"
                                        name="ingredient_name"
                                        value={formData.ingredient_name}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-select form-select-lg"
                                        name="unit"
                                        value={formData.unit}
                                        onChange={handleFormChange}
                                        required
                                    >
                                        <option value="" disabled>Select Unit</option>
 
                                            {unitsMin && unitsMin?.map((unit) => (
                                                <option key={unit.unit_name} value={unit.unit_name}>
                                                    {unit.unit_name}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Protein"
                                        className="form-control form-control-lg"
                                        name="protein"
                                        value={formData.protein}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Carb"
                                        className="form-control form-control-lg"
                                        name="carb"
                                        value={formData.carb}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Fat"
                                        className="form-control form-control-lg"
                                        name="fat"
                                        value={formData.fat}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                    {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default IngredientModal;